document.addEventListener('DOMContentLoaded', function () {
    // Find all elements with the 'uniq-showhide-wrapper' class
    const contentElements = document.querySelectorAll('.uniq-showhide-wrapper');

    contentElements.forEach(function(content, index) {
        // Create a "See More" button for each content element
        const toggleButton = document.createElement('button');
        toggleButton.textContent = 'Show more';
        toggleButton.className = 'uniq-showhide-btn';
        
        // Insert the button after the content
        content.parentNode.insertBefore(toggleButton, content.nextSibling);

        toggleButton.addEventListener('click', function () {
            // Toggle the expanded class on content
            content.classList.toggle('uniq-showhide-expanded');
            // Update button text based on the content state
            toggleButton.textContent = content.classList.contains('uniq-showhide-expanded') ? 'See less' : 'Show more';
        });
    });
});
